import React from 'react';
import Spinner from '../../../../../../components/Spinner';
import {
  ButtonBack,
  ContainerProcedure,
  SubContainer
} from '../../../certificates-constancies/type1/info/components';
import Modal from '../../../../components/Modal/Modal';
import UnregisteredPhoto from './components/Modals/UnregisteredPhoto';
import WrongPeriod from './components/Modals/WrongPeriod';
import RequestExist from '@/presentation/modules/procedures/components/Modals/RequestExists';
import { BtnRequest, CommonCard } from './components/styled';
import NotAvailable from '@/presentation/modules/procedures/components/Modals/NotAvailable';
import {
  ProcedureInfoComponent,
  StepsToFollowComponent
} from './components/ProcedureInfoComponent';
import ProcedureHeader from '@/presentation/modules/procedures/components/ContainerProcedure/Header';

const IssuanceUniversityCardInfoView = (props: any) => {
  const {
    procedureSelectedInfo,
    handleCloseModalFoto,
    showModalFotoConfirmation,
    handlerRequest,
    handleExistRequest,
    showModalInRequest,
    handleCloseModalInRequest,
    handleRedirectRegisterPhoto,
    handleBack,
    showModalNotAvailable,
    handleCloseModalNotAvailable,
    showModalCurrentPeriod,
    handleCloseModalCurrentPeriod,
    showModalProcessFinished,
    handleCloseModalProcessFinished
  } = props;

  return (
    <div data-testid="cmp-issuanceuniversityinfoview">
      <ContainerProcedure>
        <SubContainer>
          <ButtonBack onClick={handleBack} />
          <ProcedureHeader name="Emisión de carné universitario" />
        </SubContainer>
        <SubContainer>
          {!procedureSelectedInfo && <Spinner />}
          {procedureSelectedInfo && (
            <>
              <ProcedureHeader
                amount={procedureSelectedInfo?.amount}
                duration={procedureSelectedInfo?.duration}
                date={procedureSelectedInfo?.endDate}
                twoLineFormat
                paddingData={12}
              />
              <CommonCard>
                <ProcedureInfoComponent
                  deliverySchedule={procedureSelectedInfo?.deliverySchedule}
                />
              </CommonCard>
              <CommonCard>
                <StepsToFollowComponent
                  stepsToFollow={procedureSelectedInfo?.stepsToFollow}
                />
              </CommonCard>

              <BtnRequest onClick={handlerRequest}>
                {' '}
                <p>Empezar solicitud</p>
              </BtnRequest>
            </>
          )}
        </SubContainer>

        <Modal
          show={showModalInRequest}
          handleClose={handleCloseModalInRequest}
        >
          <RequestExist handleClick={handleExistRequest} />
        </Modal>
        <Modal
          show={showModalProcessFinished}
          handleClose={handleCloseModalProcessFinished}
        >
          <NotAvailable
            handleClick={handleExistRequest}
            textInformation="Ya realizaste una solicitud de carné universitario"
          />
        </Modal>
        <Modal
          show={showModalFotoConfirmation}
          handleClose={handleCloseModalFoto}
        >
          <UnregisteredPhoto
            handleClick={handleRedirectRegisterPhoto}
            handleClose={handleCloseModalFoto}
          />
        </Modal>
        <Modal
          show={showModalNotAvailable}
          handleClose={handleCloseModalNotAvailable}
        >
          <NotAvailable handleClick={handleCloseModalNotAvailable} />
        </Modal>
        <Modal
          show={showModalCurrentPeriod}
          handleClose={handleCloseModalCurrentPeriod}
        >
          <WrongPeriod handleClose={handleCloseModalCurrentPeriod} />
        </Modal>
      </ContainerProcedure>
    </div>
  );
};

export default IssuanceUniversityCardInfoView;
